export default angular.module('syTable', [])
    /**
     * @ngdoc directive
     * @name syTable.directive:table
     * @restrict A
     * @description
     * Ensures all tables are wrapped to be made responsive at
     * small device breakpoints
     */
    // @ngInject
    .directive('table', function () {
        return {
            scope: true,
            restrict: 'E',
            compile: function ($scope, $element) {
                return {
                    pre: function ($scope, $element) {
                        $element.wrap('<div class="table-responsive"></div>');
                    }
                };
            }
        };
    });
